import styled from "styled-components";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

export const TemplateWrapper = styled.div<{ colormatrix: TemplateColorObject }>`
	width: 430px;
	max-width: 100%;
	margin: 0 auto;
	position: relative;
	overflow: hidden;
	background: ${({ colormatrix }) => colormatrix.background};
	font-family: "Georgia", "Times New Roman", serif;
	min-height: 100vh;

	* {
		box-sizing: border-box;
	}

	.watercolor-bg {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 430px;
		max-width: 100%;
		height: 100%;
		background: radial-gradient(ellipse at 20% 15%, ${({ colormatrix }) => colormatrix.main}88 0%, transparent 55%),
			radial-gradient(ellipse at 80% 30%, ${({ colormatrix }) => colormatrix.main}55 0%, transparent 45%),
			radial-gradient(ellipse at 50% 70%, ${({ colormatrix }) => colormatrix.main}44 0%, transparent 60%),
			radial-gradient(ellipse at 10% 85%, ${({ colormatrix }) => colormatrix.main}33 0%, transparent 40%),
			${({ colormatrix }) => colormatrix.background};
		pointer-events: none;
		z-index: 0;
	}

	.texture-overlay {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: 430px;
		max-width: 100%;
		height: 100%;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='300' height='300' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E");
		pointer-events: none;
		z-index: 1;
		opacity: 0.5;
	}

	.section_01,
	.section_02,
	.section_03,
	.section_04,
	.section_05,
	.section_06,
	.section_07,
	.section_08 {
		position: relative;
		z-index: 2;
		width: 100%;
	}

	/* ── Section 01 Hero ── */
	.section_01 {
		padding: 30px 20px;
	}

	.hero-paper {
		position: relative;
		background: linear-gradient(
			160deg,
			${({ colormatrix }) => colormatrix.secondaryBackground}EE 0%,
			${({ colormatrix }) => colormatrix.background}CC 40%,
			${({ colormatrix }) => colormatrix.secondaryBackground}EE 100%
		);
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}44;
		border-radius: 4px;
		padding: 60px 24px;
		overflow: hidden;
		box-shadow:
			0 8px 40px rgba(0, 0, 0, 0.5),
			inset 0 0 60px rgba(0, 0, 0, 0.2);
	}

	.hero-inner {
		position: relative;
		z-index: 3;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 550px;
	}

	.ornamental-frame {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		z-index: 1;
		pointer-events: none;
	}

	.botanical-corner {
		position: absolute;
		width: 90px;
		height: 90px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		z-index: 2;
		pointer-events: none;
	}
	.botanical-tl {
		top: 0;
		left: 0;
	}
	.botanical-tr {
		top: 0;
		right: 0;
		transform: scaleX(-1);
	}
	.botanical-bl {
		bottom: 0;
		left: 0;
		transform: scaleY(-1);
	}
	.botanical-br {
		bottom: 0;
		right: 0;
		transform: scale(-1);
	}

	.wedding-of {
		font-family: "Georgia", serif;
		font-size: 13px;
		letter-spacing: 4px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 35px 0 16px;
		opacity: 0.9;
	}

	.gold-divider {
		width: 100%;
		max-width: 280px;
		height: 24px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 8px auto;
		display: block;
	}

	.main-image-wrap {
		position: relative;
		width: 220px;
		height: 280px;
		margin: 20px auto;
	}

	.main-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 2px;
		display: block;
		transition:
			brightness 0.3s,
			box-shadow 0.3s;
	}
	.main-image:hover {
		brightness: 1.05;
		box-shadow: 0 0 20px ${({ colormatrix }) => colormatrix.font.secondary}66;
	}

	.image-gold-border {
		position: absolute;
		inset: -6px;
		border: 1.5px solid ${({ colormatrix }) => colormatrix.font.secondary}88;
		border-radius: 3px;
		pointer-events: none;
	}

	.names-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 6px 0;
		gap: 0;
	}

	.groom-name,
	.bride-name {
		font-family: "Georgia", "Palatino Linotype", serif;
		font-size: 34px;
		font-weight: 400;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0;
		line-height: 1.1;
		letter-spacing: 1px;
		text-shadow: 0 2px 12px ${({ colormatrix }) => colormatrix.font.secondary}55;
	}

	.ampersand {
		font-family: "Georgia", serif;
		font-size: 26px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 2px 0;
		opacity: 0.8;
	}

	.date-text {
		font-family: "Georgia", serif;
		font-size: 18px;
		letter-spacing: 3px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		margin: 0 0 10px;
		text-transform: uppercase;
		opacity: 0.9;
	}

	.save-date-text {
		font-family: "Georgia", serif;
		font-size: 13px;
		letter-spacing: 2px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin: 16px 0;
		font-style: italic;
		opacity: 0.85;
	}

	.save-btn-wrap button {
		background: transparent !important;
		border: 1.5px solid ${({ colormatrix }) => colormatrix.button.background} !important;
		color: ${({ colormatrix }) => colormatrix.button.background} !important;
		font-family: "Georgia", serif !important;
		letter-spacing: 3px !important;
		text-transform: uppercase !important;
		font-size: 11px !important;
		padding: 10px 28px !important;
		border-radius: 1px !important;
		transition: all 0.3s !important;
		margin-bottom: 30px;
	}
	.save-btn-wrap button:hover {
		background: ${({ colormatrix }) => colormatrix.button.background}22 !important;
	}

	/* ── Section 02 Countdown ── */
	.section_02 {
		padding: 12px 20px 28px;
	}

	.countdown-paper {
		background: linear-gradient(
			135deg,
			${({ colormatrix }) => colormatrix.secondaryBackground}CC,
			${({ colormatrix }) => colormatrix.background}AA
		);
		border-top: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
		border-bottom: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
		padding: 28px 16px 32px;
		text-align: center;
	}

	.countdown-label {
		font-family: "Georgia", serif;
		font-size: 11px;
		letter-spacing: 5px;
		text-transform: uppercase;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		margin-bottom: 14px;
		opacity: 0.8;
	}
	.counter_boxes_wrapper {
		display: flex;
		justify-content: center;
		gap: 16px;
	}
	.counter_boxes_wrapper .counter_box_wrapper {
		background: transparent !important;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}44 !important;
		border-radius: 2px !important;
		color: ${({ colormatrix }) => colormatrix.font.secondary} !important;
		font-family: "Georgia", serif !important;
		min-width: 64px !important;
		padding: 10px;
	}

	/* ── Section 03 Partners ── */
	.section_03 {
		padding: 12px 20px 32px;
	}

	.section-inner {
		padding: 24px 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.dua-text {
		font-family: "Amiri", "Traditional Arabic", serif;
		font-size: 18px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		text-align: center;
		line-height: 2;
		margin: 0 0 12px;
		direction: rtl;
		opacity: 0.9;
	}

	.main-intro {
		font-family: "Georgia", serif;
		font-size: 14px;
		line-height: 1.9;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		text-align: center;
		margin: 14px 0 6px;
		opacity: 0.85;
		padding: 0 8px;
	}

	.sub-intro {
		font-family: "Georgia", serif;
		font-size: 13px;
		font-style: italic;
		line-height: 1.8;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		text-align: center;
		margin: 0 0 20px;
		padding: 0 8px;
		opacity: 0.8;
	}

	.partners-grid {
		display: flex;
		align-items: flex-start;
		justify-content: center;
		gap: 0;
		width: 100%;
		margin-top: 20px;
	}

	.partner-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
		padding: 0 8px;
	}

	.partner-img-frame {
		position: relative;
		width: 120px;
		height: 150px;
		border: 1.5px solid ${({ colormatrix }) => colormatrix.font.secondary}55;
		padding: 4px;
		background: ${({ colormatrix }) => colormatrix.secondaryBackground};
	}

	.partner-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		border-radius: 1px;
		transition:
			opacity 0.3s,
			box-shadow 0.3s;
	}
	.partner-img:hover {
		opacity: 0.9;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	}

	.partner-name {
		font-family: "Georgia", serif;
		font-size: 18px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0;
		text-align: center;
		letter-spacing: 0.5px;
	}

	.partner-divider-vert {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 30px;
		gap: 4px;
	}

	.vert-line {
		width: 1px;
		height: 60px;
		background: linear-gradient(
			to bottom,
			transparent,
			${({ colormatrix }) => colormatrix.font.secondary}55,
			transparent
		);
	}

	.heart-icon {
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		font-size: 18px;
		opacity: 0.8;
	}

	/* ── Section 04 Quran ── */
	.section_04 {
		padding: 12px 20px 28px;
	}

	.quran-paper {
		position: relative;
		background: linear-gradient(
			160deg,
			${({ colormatrix }) => colormatrix.secondaryBackground}DD,
			${({ colormatrix }) => colormatrix.background}BB
		);
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
		border-radius: 2px;
		padding: 32px 24px;
		overflow: hidden;
	}

	.quran-inner {
		position: relative;
		z-index: 3;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}

	.quran-basmala {
		font-family: "Amiri", "Traditional Arabic", serif;
		font-size: 22px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0 0 10px;
		direction: rtl;
		line-height: 1.8;
	}

	.quran-verse {
		font-family: "Amiri", "Traditional Arabic", serif;
		font-size: 16px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		direction: rtl;
		line-height: 2.2;
		margin: 10px 0;
		opacity: 0.9;
	}

	.quran-sadaqa {
		font-family: "Amiri", "Traditional Arabic", serif;
		font-size: 18px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 10px 0 0;
		direction: rtl;
		line-height: 1.8;
		opacity: 0.9;
	}

	/* ── Section 05 Love Story ── */
	.section_05 {
		padding: 12px 20px 32px;
	}

	.section-title {
		font-family: "Georgia", "Palatino Linotype", serif;
		font-size: 22px;
		font-weight: 400;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		text-align: center;
		letter-spacing: 3px;
		text-transform: uppercase;
		margin: 0 0 8px;
	}

	.story-image-wrap {
		position: relative;
		width: 100%;
		height: 220px;
		margin: 20px 0;
		overflow: hidden;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
	}

	.story-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		transition: opacity 0.3s;
	}
	.story-image:hover {
		opacity: 0.92;
	}

	.story-img-overlay {
		position: absolute;
		inset: 0;
		background: linear-gradient(to bottom, transparent 60%, ${({ colormatrix }) => colormatrix.background}CC);
		pointer-events: none;
	}

	.story-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 0 4px;
		margin-top: 12px;
	}

	.story-item {
		display: flex;
		gap: 14px;
		align-items: flex-start;
	}

	.story-dot {
		width: 10px;
		height: 10px;
		border-radius: 50%;
		border: 1.5px solid ${({ colormatrix }) => colormatrix.font.secondary};
		background: transparent;
		margin-top: 5px;
		flex-shrink: 0;
	}

	.story-content {
		flex: 1;
	}

	.story-title {
		font-family: "Georgia", serif;
		font-size: 15px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 0 0 4px;
		letter-spacing: 0.5px;
	}

	.story-description {
		font-family: "Georgia", serif;
		font-size: 13px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		margin: 0;
		line-height: 1.7;
		opacity: 0.8;
	}

	.add_story {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		border: 1.5px dashed ${({ colormatrix }) => colormatrix.font.secondary}66;
		border-radius: 2px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		margin: 16px auto;
		cursor: pointer;
		transition: background 0.2s;
	}
	.add_story:hover {
		background: ${({ colormatrix }) => colormatrix.font.secondary}11;
	}

	/* ── Section 06 Gallery ── */
	.section_06 {
		padding: 28px 16px 32px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		z-index: 2;
	}

	.gallery-wrap {
		margin-top: 16px;
	}

	/* ── Section 07 Comments ── */
	.section_07 {
		padding: 12px 20px 32px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		z-index: 2;
	}

	.comments-text {
		font-family: "Georgia", serif;
		font-size: 15px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		text-align: center;
		line-height: 1.8;
		margin: 12px 0 4px;
		opacity: 0.88;
	}

	.comment-sub-text {
		font-family: "Georgia", serif;
		font-size: 13px;
		font-style: italic;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		text-align: center;
		margin: 0 0 16px;
		opacity: 0.75;
	}

	/* ── Section 08 Location ── */
	.section_08 {
		padding: 12px 20px 40px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		z-index: 2;
	}

	.section_08 button {
		background: transparent !important;
		border: 1.5px solid ${({ colormatrix }) => colormatrix.button.background} !important;
		color: ${({ colormatrix }) => colormatrix.button.background} !important;
		font-family: "Georgia", serif !important;
		letter-spacing: 3px !important;
		text-transform: uppercase !important;
		font-size: 11px !important;
		padding: 10px 28px !important;
		border-radius: 1px !important;
	}

	.location-text {
		font-family: "Georgia", serif;
		font-size: 14px;
		color: ${({ colormatrix }) => colormatrix.font.primary};
		text-align: center;
		line-height: 1.8;
		margin: 12px 0 16px;
		opacity: 0.88;
	}

	.map-wrap {
		width: 100%;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
		margin-bottom: 16px;
		overflow: hidden;
	}

	.map-btn-wrap {
		margin-bottom: 24px;
	}

	.conclusion-img-wrap {
		position: relative;
		width: 100%;
		height: 200px;
		overflow: hidden;
		border: 1px solid ${({ colormatrix }) => colormatrix.font.secondary}33;
		margin-bottom: 20px;
	}

	.conclusion-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		transition: opacity 0.3s;
	}
	.conclusion-img:hover {
		opacity: 0.92;
	}

	.conclusion-img-overlay {
		position: absolute;
		inset: 0;
		background: ${({ colormatrix }) => colormatrix.overlay};
		pointer-events: none;
	}

	.names-conclusion {
		font-family: "Georgia", serif;
		font-size: 22px;
		color: ${({ colormatrix }) => colormatrix.font.secondary};
		text-align: center;
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
		justify-content: center;
		margin-bottom: 10px;
	}

	.and-text {
		font-size: 14px;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		opacity: 0.75;
		font-style: italic;
	}

	.conclusion-text {
		font-family: "Georgia", serif;
		font-size: 13px;
		font-style: italic;
		color: ${({ colormatrix }) => colormatrix.font.tertiary};
		text-align: center;
		line-height: 1.8;
		opacity: 0.75;
		margin: 4px 0 0;
	}

	/* ── Global ── */
	.shaded {
		opacity: 0.3 !important;
	}

	.animate-on-scroll {
		opacity: 1;
		transform: translateY(0);
	}

	img {
		max-width: 100%;
	}
`;
